function DeleteButton({ text, customFn }) {
  return (
    <button
      className='btn btn-outline-danger  mr-1'
      onClick={() => customFn && customFn()}
    >
      {text ? text : 'Delete'}
    </button>
  )
}

export default DeleteButton
